// components/TransactionDetails.tsx
import React from "react";
import { PaymentData } from "../../../types";

interface Props {
  paymentData: PaymentData | null;
}

const TransactionDetails: React.FC<Props> = ({ paymentData }) => {
  if (!paymentData) {
    return <p>Loading transaction details...</p>;
  }

  return (
    <div className="mx-3 mx-md-3">
      <h6>Transaction Details</h6>
      <table className="table mb-0 mb-md-2">
        <tbody>
          <tr className="transaction-details-borders">
            <td>
              <b>Merchant:</b>
            </td>
            <td>{paymentData.payment?.merchantDisplayName || "N/A"}</td>
          </tr>
          {paymentData.payment?.amount ? (
            <tr className="transaction-details-borders">
              <td>
                <b>Amount:</b>
              </td>
              <td className="text-primary">
                {new Intl.NumberFormat("en-NZ", {
                  style: "currency",
                  currency: "NZD",
                }).format(paymentData.payment.amount / 100)}
              </td>
            </tr>
          ) : null}
          <tr className="transaction-details-borders">
            <td>
              <b>Reference:</b>
            </td>
            <td>{paymentData.payment?.reference || "N/A"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TransactionDetails;
